import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    selectablesContainer: {
      display: "flex",
      [theme.breakpoints.up("sm")]: {
        paddingLeft: "1rem"
      }
    },

    storeSelectorContainer: {
      alignItems: "start",
      [theme.breakpoints.down("sm")]: {
        marginRight: "0.5rem",
        marginLeft: "0.5rem"
      },
      [theme.breakpoints.up("sm")]: {
        marginRight: "1rem",
        marginLeft: "1rem"
      }
    },
    storesSelector: {
      width: "100%",
      paddingBottom: "1rem"
    },

    storeSelectorDivider: {
      width: "100%",
      height: "1px",
      backgroundColor: "#e5e5e5",
      border: "none"
    },
    paddingTop15: {
      paddingTop: "1.5rem"
    },
    paddingTop1: {
      paddingTop: "1rem"
    },
    dateSelector: {
      width: "7rem"
    },
    graphTypeSelector: {
      paddingRight: "1rem"
    },
    sectionContent: {
      "& .MuiPaper-root.MuiCard-root.MuiPaper-elevation1.MuiPaper-rounded": {
        boxShadow: "none !important"
      },
      [theme.breakpoints.down("sm")]: {
        "& .MuiPaper-root.MuiCard-root.MuiPaper-elevation1.MuiPaper-rounded > .MuiCardContent-root":
          {
            padding: 0
          }
      }
    },
    container: {
      position: "relative",
      padding: "0 !important"
    },
    chartsContainer: {
      "& .MuiCardHeader-root": {
        display: "none !important"
      },
      marginTop: "2rem"
    },
    header: {
      "& .MuiTypography-body2": {
        fontSize: "1.1em !important"
      }
    },
    avatar: {
      backgroundColor: "#05598d"
    },
    link: {
      color: "#05598d",
      textTransform: "uppercase",
      fontWeight: "bold"
    },
    salesSummary: {
      paddingTop: "0.5em",
      paddingRight: "1rem",
      "& .value": {
        fontWeight: "bold",
        fontSize: "large",
        lineHeight: "initial",
        color: "#645656"
      }
    }
  })
);
